import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import files from './modules/Files'
import Auth from './modules/Auth';
import UI from './modules/UI';
import TimeKeeping from './modules/TimeKeeping';
import Budget from './modules/Budget';
import Emulation from './modules/Emulation';


const state = {
    sidebarShow: 'responsive',
    sidebarMinimize: false
}

const mutations = {
    toggleSidebarDesktop(state) {
        const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarOpened ? false : 'responsive'
    },
    toggleSidebarMobile(state) {
        const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarClosed ? true : 'responsive'
    },
    set(state, [variable, value]) {
        state[variable] = value
    }
}

const store = new Vuex.Store({
  state,
  mutations,
  modules: {
    files,
    auth: Auth,
    ui: UI,
    TimeKeepingStore: TimeKeeping,
    Budget: Budget,
    EmulationStore:Emulation,
  }
});

export default store;
